/* src/modules/index.js */

/* Scenes */
import Announcement from './announcement/Scene';
import CourseApprovals from './course_approvals/Scene';
import Courses from './courses/Scene';
import Dashboard from './dashboard/Scene';
import Discounts from './discounts/Scene';
import Interviews from './interviews/Scene';
import Lessons from './lessons/Scene';
import Locations from './locations/Scene';
import Messages from './messages/Scene';
import Notification from './notification/Scene';
import Requests from './requests/Scene';
import Students from './students/Scene';
import Survey from './survey/Scene';
import Tutors from './tutors/Scene';
import Universities from './universities/Scene';
import CreateTutor from './create_tutor/Scene';
import Organization from './organization/Scene';
import Subsidy from './subsidy/Scene';
import Program from './program/Scene';
import CreditedHistory from './credited_history/Scene';

/* Reducers */
import appStateReducer from './app_state/reducers';
import announcementReducer from './announcement/reducers';
import authReducer from './auth/reducers';
import courseApprovalsReducer from './course_approvals/reducers';
import coursesReducer from './courses/reducers';
import createTutorReducer from './create_tutor/reducers';
import dashboardReducer from './dashboard/reducers';
import discountsReducer from './discounts/reducers';
import lessonsReducer from './lessons/reducers';
import locationsReducer from './locations/reducers';
import messagesReducer from './messages/reducers';
import notificationReducer from  './notification/reducers';
import interviewsReducer from './interviews/reducers';
import requestsReducer from './requests/reducers';
import studentsReducer from './students/reducers';
import surveyReducer from './survey/reducers';
import tutorsReducer from './tutors/reducers';
import universitiesReducer from './universities/reducers';
import organizationReducer from './organization/reducers';
import subsidyReducer from './subsidy/reducers';

export const Scenes = {
  Announcement,
  CourseApprovals,
  Courses,
  Dashboard,
  Discounts,
  Interviews,
  Lessons,
  Locations,
  Messages,
  Notification,
  Requests,
  Students,
  Survey,
  Tutors,
  Universities,
  CreateTutor,
  Organization,
  Subsidy,
  CreditedHistory,
};

export const Reducers = {
  appStateReducer,
  announcementReducer,
  authReducer,
  courseApprovalsReducer,
  coursesReducer,
  createTutorReducer,
  dashboardReducer,
  discountsReducer,
  interviewsReducer,
  lessonsReducer,
  locationsReducer,
  messagesReducer,
  notificationReducer,
  requestsReducer,
  studentsReducer,
  surveyReducer,
  tutorsReducer,
  universitiesReducer,
  organizationReducer,
  subsidyReducer,
};



// WEBPACK FOOTER //
// ./src/modules/index.js